<template>
  <v-row class="text-center">
    <v-col cols="12">
      <v-progress-linear :indeterminate="true" v-if="isLoading" color="primary"></v-progress-linear>
      <GChart
        v-else
        type="BarChart"
        :data="chartData"
        :options="chartOptions"
        width="100%"
      />
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { GChart } from 'vue-google-charts/legacy';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'GraphPipeline',
  mixins: [loading],
  module: 'Reports',
  components: {
    GChart,
  },
  props: {
    lineType: {
      type: String,
      default: 'Monthly Recurring Cost',
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapState('currencies', ['selectedCurrency']),
    ...mapGetters('currencies', ['currencySymbol']),
    chartData() {
      const { items } = this;
      const data = [['Status', 'Total Profit']];
      const statuses = ['Prospecting', 'Negotiating'];
      statuses.forEach((status) => {
        const total = items
          .filter((item) => item.agreement.status === status)
          .reduce((sum, item) => sum + item.profit, 0);
        data.push([status, total]);
      });
      return data;
    },
    maxValue() {
      const { chartData } = this;
      const profits = chartData
        .slice(1)
        .map((row) => row.slice(1).reduce((sum, value) => sum + value, 0));
      return Math.max(...profits) * 1.1;
    },
    chartOptions() {
      const { maxValue } = this;
      return {
        animation: {
          duration: 1000,
          easing: 'out',
        },
        chart: {
          title: 'Overview',
        },
        vAxis: {
          format: `${this.currencySymbol} #,###`, title: '', minValue: 0, maxValue,
        },
        hAxis: {
          minorGridlines:
        { minSpacing: 100 },
          title: '',
        },
        height: 280,
        colors: ['#1B99E8', '#F11A16'],
        legend: { position: 'top' },
        // isStacked: true,
        annotations: {
          alwaysOutside: true,
          stem: {
            length: 5,
          },
          textStyle: {
            // The color of the text.
            color: '#000000',
          },
        },
      };
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    /**
     * Executes refresh
     */
    async refresh() {
      this.isLoading = true;
      this.items = [];
      let url = 'odata/incomeLines?';
      url += '$filter=(agreement/Status eq \'Prospecting\' OR agreement/Status eq \'Negotiating\')';
      url += ` AND lineType eq '${this.lineType}' AND isDeleted eq false AND isActive eq true`;
      url += '&$expand=agreement($select=status)';
      const { data } = await this.$http.get(url);
      this.items = data.value;
      this.isLoading = false;
    },
  },
};
</script>
